// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-f06212fa] .disabled {\n  cursor: not-allowed;\n}\n[data-v-f06212fa] .modal-footer > div {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  margin: 0;\n}\n.success-icon svg[data-v-f06212fa] {\n  font-size: 60px;\n}\n", ""]);
// Exports
module.exports = exports;
